module.exports = __webpack_public_path__ + "static/media/icon-dark.00542ef5.svg";